import { v4 as uuidv4 } from 'uuid';
import ChequeKizMarkGridPluginSettings from './ChequeKizMarkGridPluginSettings';
import ChequeKizMarkGrid from './ChequeKizMarkGrid';

export const ChequeKizMarkTab = (): ITab => {
    return {
        id: uuidv4(),
        title: 'Выбытие',
        view: {
            content: ChequeKizMarkGridPluginSettings
                ? <ChequeKizMarkGrid gridId={uuidv4()} plugin={ChequeKizMarkGridPluginSettings} />
                : <p> Справочник не настроен </p>
        }
    }
}

export default ChequeKizMarkTab